<template>
  <small class="app-input-help-text">
    <slot />
  </small>
</template>

<script>
export default {
  name: 'AppInputHelpText',
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';

.app-input-help-text {
  text-align: right;
  font-size: 75%;
  line-height: 120%;
  color: $mutedColor;
  margin-top: 0.25rem;
}
</style>
